import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Dialog } from '@material-ui/core';
import { colors, Typography } from 'kangarootime-ui';
import PhotoGrid from './PhotoGrid';

const AllPhotosSentToday = ({ isOpen, onClose, photos }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} disableEnforceFocus={false}>
      <Card style={{ overflow: 'scroll', maxHeight: '80vh' }}>
        <CardHeader style={{ backgroundColor: colors.brand_1, color: '#FFFFFF' }} title='Photos Sent Today' />
        <CardContent>
          { photos.length > 0
            ? <PhotoGrid photos={photos} />
            : <Typography>No photos have been sent today</Typography>
          }
        </CardContent>
      </Card>
    </Dialog>
  );
};

AllPhotosSentToday.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  photos: PropTypes.array
};

export default AllPhotosSentToday;
